import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'lib-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ListComponent {
  @Input() addMoreVisible: boolean;
  @Input() addMoreText: string;
  @Input() error: boolean;
  @Output() addMore = new EventEmitter<HTMLElement>();
  @Output() blurred = new EventEmitter<boolean>();

  @ViewChild('list') listRef: ElementRef;

  constructor(private zone: NgZone) {}

  onAddMore($event) {
    this.addMore.emit($event.target);
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        const newListItem = (
          this.listRef.nativeElement as HTMLElement
        ).lastElementChild?.querySelector('.list-item-container');
        const firstFocusable = newListItem?.querySelector(
          'input, textarea, button, a, [tabindex="0"]:not(.focus-anchor)',
        ) as HTMLElement;
        firstFocusable?.focus();
      });
    });
  }

  buttonBlurred() {
    this.blurred.emit(true);
  }
}
